import React from "react";
import { useTranslation } from "react-i18next";
import { Eraser, Loader2 } from "lucide-react";

// What a Clear button shows while it runs: "Connecting…", then the erase's
// percentage with the button filling up behind it (firmware v0.15.0+), or a
// spinner when the wearable doesn't report one. The button needs `relative
// overflow-hidden`. `progress` is { stage: connecting | clearing, pct } or
// null (not heard from yet, so still connecting).
const ClearProgress = ({ progress }) => {
  const { t } = useTranslation();
  const pct = progress?.stage === "clearing" ? progress.pct : null;
  const label =
    pct != null
      ? t("common.clearProgress.clearingPct", { pct })
      : progress?.stage === "clearing"
      ? t("common.clearProgress.clearing")
      : t("common.clearProgress.connecting");
  return (
    <>
      {pct != null && (
        <span
          aria-hidden="true"
          className="absolute inset-0 origin-left bg-[#FEE2E2] transition-transform duration-300 ease-out"
          style={{ transform: `scaleX(${pct / 100})` }}
        />
      )}
      <span className="relative flex items-center gap-1.5 tabular-nums">
        {pct != null ? (
          <Eraser size={13} />
        ) : (
          <Loader2 size={13} className="animate-spin" />
        )}
        {label}
      </span>
    </>
  );
};

export default ClearProgress;
